// 请求错误页面
export default [
    {
        path: 'error/index',
        component: () => import('@/views/error/index.vue'),
        meta: {
            title: '暂无数据',
        },
    },
]